module.exports = __webpack_public_path__ + "static/media/vehicle-no-photo.9fd5b21c.svg";